import { debounce } from '@material-ui/core'
import { Button } from './BaseActionButtons.style'
import { ButtonProps } from '../Button'

type CancelButtonVariant = 'text' | 'outlined'

interface BaseActionButtonsProps {
  onCancel?: () => void
  cancelText?: string
  onSubmit?: () => void
  submitText: string
  cancelButtonVariant?: CancelButtonVariant
  submitDisabled?: boolean
  idPrefix?: string
  isLoading?: boolean
  submitButtonProps?: Partial<ButtonProps>
  cancelButtonProps?: Partial<ButtonProps>
}

const BaseActionButtons = ({
  onCancel,
  cancelText,
  onSubmit,
  submitText,
  cancelButtonVariant,
  submitDisabled,
  idPrefix,
  isLoading,
  submitButtonProps,
  cancelButtonProps,
}: BaseActionButtonsProps) => {
  return (
    <>
      {onCancel && (
        <Button
          onClick={debounce(onCancel, 200)}
          variant={cancelButtonVariant}
          id={idPrefix && `${idPrefix}-cancel-btn`}
          {...cancelButtonProps}
        >
          {cancelText}
        </Button>
      )}
      <Button
        {...(onSubmit
          ? { onClick: debounce(onSubmit, 200) }
          : { type: 'submit' })}
        variant="contained"
        disabled={submitDisabled}
        id={idPrefix && `${idPrefix}-submit-btn`}
        isLoading={isLoading}
        {...submitButtonProps}
      >
        {submitText}
      </Button>
    </>
  )
}

export default BaseActionButtons
